import { PATHS } from "./routes.js";

/**
 * Where signing in happens, and where it sends you afterwards.
 *
 * `/` belongs to the public site for anyone signed out (the API serves it), so
 * signing in needs an address of its own. A signed-out visit to any screen is
 * sent here with the screen in `next`, and a successful sign-in goes back to
 * it: a link from an email opens the screen it named, not the Overview.
 */
export const SIGN_IN = "/sign-in";

/**
 * A `next` that is a path on this site, or the Overview.
 *
 * Checked, not trusted: `next` is in the address bar, and a sign-in page that
 * forwards anywhere it is told is an open redirect, the classic way to make a
 * phishing link look like it came from us.
 */
export function safeNext(next: string | null): string {
  if (next?.startsWith("/") !== true) return PATHS.overview;
  // `//evil.com` and `/\evil.com` are other sites to a browser.
  if (next.startsWith("//") || next.startsWith("/\\")) return PATHS.overview;
  if (
    next === SIGN_IN ||
    next.startsWith(`${SIGN_IN}?`) ||
    next.startsWith(`${SIGN_IN}/`)
  ) {
    return PATHS.overview;
  }
  return next;
}

/** The sign-in address for a signed-out visit to `from` (a path with its query). */
export function signInFor(from: string): string {
  if (from === "/" || from === "" || safeNext(from) === PATHS.overview) return SIGN_IN;
  return `${SIGN_IN}?next=${encodeURIComponent(from)}`;
}
